import type { AxiosError } from 'axios';
import type { InitiateOtpResponse } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';

interface InitiateOtpVariables {
  magicToken?: string;
  email?: string;
}

export function useInitiateOtp() {
  return useApiMutation<InitiateOtpResponse, AxiosError, InitiateOtpVariables>({
    mutationFn:
      (api) =>
      async ({ magicToken, email }) => {
        const response = await api.otp.creatorsAuthOTPControllerInitiateOtp(
          magicToken,
          email ? { email } : {}
        );
        return response.data;
      },
  });
}
